import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const LocateIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <circle cx="12" cy="12" r="4" />
    <line x1="12" y1="2" x2="12" y2="5" />
    <line x1="12" y1="19" x2="12" y2="22" />
    <line x1="2" y1="12" x2="5" y2="12" />
    <line x1="19" y1="12" x2="22" y2="12" />
  </svg>
);

export default LocateIcon;
